<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Дата</label>
        <crm-datepicker
          [(value)]="plannedIncome.date"
          [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
          appendTo="body"></crm-datepicker>
        <small
          *ngIf="errors?.date"
          class="p-error">
          {{ errors.date | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Компания</label>
        <crm-single-select
          [options]="companies"
          [(selectedItem)]="plannedIncome.company"
          [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
          [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
          [showClear]="true"
          (selectedItemChange)="changeCompany()"
          appendTo="body">
        </crm-single-select>
        <small
          *ngIf="errors?.company"
          class="p-error">
          {{ errors.company | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Валюта</label>
        <crm-currency-single-select
          [currencies]="currencies"
          [(selectedCurrency)]="plannedIncome.currency"
          [customSearch]="true"
          [showClear]="false"
          [disabled]="!plannedIncome.company"
          [isError]="$any(errors?.currency)"
          (selectedCurrencyChange)="plannedIncome['rate'] = $event?.latestRate?.rate"
          appendTo="body"></crm-currency-single-select>

        <small
          *ngIf="errors?.currency"
          class="p-error">
          {{ errors.currency | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Сумма</label>
        <p-inputNumber
          [(ngModel)]="plannedIncome.amount"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          (onInput)="plannedIncome.amount = $event.value"
          [ngClass]="{ 'ng-invalid ng-dirty': errors?.amount }"></p-inputNumber>
        <div
          *ngIf="plannedIncome.currency && plannedIncome.currency?.isoCharacter !== 'RUB' && plannedIncome.amount"
          class="text-medium text-lg uppercase mt-2">
          Сумма:
          {{ (plannedIncome.amount || 0) * (plannedIncome['rate'] || 0) | currency: 'RUB':'symbol':'1.2-2' }}
        </div>
        <small
          *ngIf="errors?.amount"
          class="p-error">
          {{ errors.amount | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">БС</label>
        <crm-direction-single-select
          [directions]="directions"
          [(selectedDirection)]="plannedIncome.direction"
          [groupsDisabled]="true"
          [showClear]="true"
          [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
          [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
          appendTo="body">
        </crm-direction-single-select>
        <small
          *ngIf="errors?.direction"
          class="p-error">
          {{ errors.direction | join }}
        </small>
      </div>

      <div class="field">
        <label
          class="font-medium"
          [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
          Бизнес единица
        </label>
        <crm-unit-single-select
          [(selectedUnit)]="plannedIncome.unit"
          [isError]="$any(errors?.unit)"
          [showClear]="true"
          appendTo="body"></crm-unit-single-select>
        <small
          *ngIf="errors?.unit"
          class="p-error">
          {{ errors.unit | join }}
        </small>
      </div>

      <div class="field">
        <label
          class="font-medium"
          [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
          Филиал
        </label>
        <crm-filial-single-select
          [(selectedFilial)]="plannedIncome.filial"
          [isError]="$any(errors?.filial)"
          [showClear]="true"
          appendTo="body"></crm-filial-single-select>
        <small
          *ngIf="errors?.filial"
          class="p-error">
          {{ errors.filial | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Сделка</label>
        <crm-deal-auto-complete
          [(selectedDeal)]="plannedIncome.deal"
          [isError]="$any(errors?.deal)"
          [showClear]="true"
          appendTo="body"></crm-deal-auto-complete>
        <small
          *ngIf="errors?.deal"
          class="p-error">
          {{ errors.deal | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Контрагент</label>
        <crm-contragent-auto-complete
          [(selectedContragent)]="plannedIncome.contragent"
          [customSearch]="false"
          [isError]="$any(errors?.contragent)"></crm-contragent-auto-complete>
        <small
          *ngIf="errors?.contragent"
          class="p-error">
          {{ errors.contragent | join }}
        </small>
      </div>

      <div
        *ngIf="(form$ | async)?.isEdit"
        class="field-checkbox">
        <p-checkbox
          [(ngModel)]="plannedIncome.incomesReceived"
          [binary]="true"
          (ngModelChange)="setIncomesReceived()"
          inputId="incomesReceived"></p-checkbox>
        <label [for]="'incomesReceived'">Оплачено</label>
      </div>
    </div>
  </p-card>

  <p-card
    header="Участники"
    styleClass="my-3">
    <div class="field">
      <label class="font-medium">Ответственный</label>
      <crm-user-single-select
        [(selectedUser)]="plannedIncome.responsible"
        [showClear]="true"></crm-user-single-select>
    </div>

    <h3 class="font-medium -mb-2">Аудиторы</h3>
    <p-divider></p-divider>

    <div class="formgrid grid">
      <div class="field lg:col-6 col-12">
        <label class="font-medium">Пользователи</label>
        <crm-user-multi-select
          [(selectedUsers)]="plannedIncome.userAuditors"
          [isFloatLabel]="false"></crm-user-multi-select>
      </div>
      <div class="field lg:col-6 col-12">
        <label class="font-medium">Группы</label>
        <crm-multi-select
          [(selectedItems)]="plannedIncome.userGroupAuditors"
          [options]="userGroups">
        </crm-multi-select>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="savePlannedIncome()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deletePlannedIncome()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
